module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorTitle":"Page not found","errorMessage":"We could not find the page you are looking for","goBackHomeMessage":"Go back home page"},"es":{"errorTitle":"Página no encontrada","errorMessage":"No hemos podido encontrar la página que busca","goBackHomeMessage":"Volver a la página de inicio"}}')
  delete Component.options._Ctor
}
